import moment from "moment";

export const formatShippingDate = (d: any): string => {
  return moment(d).format("DD.MM.YYYY");
};
